import React, { useRef, useState, useEffect, useContext } from "react";
import "../styles/PYQs.css";
import Navbar from "../components/Navbar";
import Scale from "../assets/images/scale.webp";
import NotePreview from "./NotePreview";
import emailjs from "emailjs-com";
import HomeContactSection from "../components/HomeContactSection";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { auth } from "../firebase";
import { Helmet } from "react-helmet";
import { AuthContext } from "../App";

// Subjects data remains as in your code
const subjects = {
  BALLB: {
    1: [
      "English-I",
      "Indian History",
      "Political Science-I",
      "Legal Language",
      "History of Courts",
    ],
    2: [
      "English-II",
      "Political Science-II",
      "Psychology",
      "Law of Torts",
      "Consumer Protection Law",
    ],
    3: [
      "Sociology-I",
      "Political Science-III",
      "Economics-I",
      "Law of Contract-I",
      "Family Law-I",
    ],
    4: [
      "Sociology-II",
      "Economics-II",
      "Environmental Studies",
      "Law of Contracts-II",
      "Family Law-II",
    ],
    5: [
      "Criminal Law-I",
      "Constitutional Law-I",
      "Corporate Law-I",
      "Environmental Law",
      "Law of Evidence",
    ],
    6: [
      "Criminal Law-II",
      "Constitutional Law-II",
      "Corporate Law-II",
      "Jurisprudence",
      "Law of Property",
    ],
    7: [
      "Labour Law-I",
      "Public International Law",
      "Administrative Law",
      "Law of Insurance",
      "Intellectual Property Law",
    ],
    8: [
      "Labour Law-II",
      "Interpretation of Statutes",
      "Private International Law",
      "Land Laws",
      "Citizenship and Emigration Law",
    ],
    9: [
      "CPC and Law of Limitation",
      "BNSS, 2023",
      "Law of Banking and Negotiable Instruments",
      "Alternative Dispute Resolution",
      "Professional Ethics and Professional Accounting",
    ],
    10: [
      "Law of Taxation",
      "Information Technology Law",
      "Optional- Law Relating to Women",
      "Optional- Human Rights Law",
      "Drafting Pleadings and Conveyancing",
    ],
  },
  BBALLB: {
    1: [
      "English-I",
      "Principles of Management",
      "Business Economics",
      "Financial Accounting",
      "History of Courts",
    ],
    2: [
      "English-II",
      "Human Resource Management",
      "Principles of Marketing",
      "Elements of Financial Management",
      "Law of Torts",
    ],
    3: [
      "Principles of Organisational Behaviour",
      "Business Statistics",
      "Management Information Systems",
      "Law of Contract-I",
      "Family Law-I",
    ],
    4: [
      "Business Communication",
      "Enterpreneurship",
      "Advertising and Salesmanship",
      "Law of Contracts-II",
      "Family Law-II",
    ],
    5: [
      "International Trade",
      "Environmental Studies",
      "Criminal Law-I",
      "Constitutional Law-I",
      "Corporate Law-I",
    ],
    6: [
      "Business Policy and Strategy",
      "Environmental Law",
      "Criminal Law-II",
      "Constitutional Law-II",
      "Corporate Law-II",
    ],
    7: [
      "Labour Law-I",
      "Public International Law",
      "Administrative Law",
      "Law of Property",
      "Jurisprudence",
    ],
    8: [
      "Labour Law-II",
      "Intellectual Property Law",
      "Land Laws",
      "Interpretation of Statutes",
      "Law of Evidence",
    ],
    9: [
      "CPC and Law of Limitation",
      "BNSS, 2023",
      "Law of Banking and Negotiable Instruments",
      "Alternative Dispute Resolution",
      "Professional Ethics and Professional Accounting",
    ],
    10: [
      "Law of Taxation",
      "Law of Insurance",
      "Optional- Law Relating to Women",
      "Optional- Human Rights Law",
      "Drafting Pleadings and Conveyancing",
    ],
  },
  BCOMLLB: {
    1: [
      "English-I",
      "Financial Accounting-I",
      "Business Economics",
      "Business Organization",
      "History of Courts",
    ],
    2: [
      "English-II",
      "Financial Accounting-II",
      "Principles of Management",
      "Foreign Trade",
      "Law of Torts and Consumer Protection",
    ],
    3: [
      "Advanced Accounting",
      "Business Statistics-I",
      "Corporate Accounting",
      "Law of Contract-I",
      "Family Law-I",
    ],
    4: [
      "Business Statistics-II",
      "Cost Accounting",
      "Financial Management",
      "Law of Contracts-II",
      "Family Law-II",
    ],
    5: [
      "Managerial Accounting",
      "Environmental Studies",
      "Criminal Law-I",
      "Constitutional Law-I",
      "Corporate Law-I",
    ],
    6: [
      "Financial Institutions and Markets",
      "Environmental Law",
      "Criminal Law-II",
      "Constitutional Law-II",
      "Corporate Law-II",
    ],
    7: [
      "Labour Law-I",
      "Public International Law",
      "Administrative Law",
      "Law of Property",
      "Jurisprudence",
    ],
    8: [
      "Labour Law-II",
      "Intellectual Property Law",
      "Land Laws",
      "Interpretation of Statutes",
      "Law of Evidence",
    ],
    9: [
      "CPC and Law of Limitation",
      "BNSS, 2023",
      "Law of Banking and Negotiable Instruments",
      "Alternative Dispute Resolution",
      "Professional Ethics and Professional Accounting",
    ],
    10: [
      "Law of Taxation",
      "Law of Insurance",
      "Optional- Law Relating to Women",
      "Optional- Human Rights Law",
      "Drafting Pleadings and Conveyancing",
    ],
  },
  "3YDC": {
    1: [
      "Law of Contract-I",
      "Family Law-I",
      "Constitutional Law-I",
      "Law of Torts",
      "Environmental Law",
    ],
    2: [
      "Law of Contract-II",
      "Family Law-II",
      "Constitutional Law-II",
      "Law of Crimes",
      "Law of Evidence",
    ],
    3: [
      "Jurisprudence",
      "Law of Property",
      "Administrative Law",
      "Company Law",
      "Labour Law-I",
    ],
    4: [
      "Labour Law-II",
      "Public International Law",
      "Interpretation of Statutes",
      "Land Laws",
      "Intellectual Property Law",
    ],
    5: [
      "CPC",
      "BNSS, 2023",
      "Law of Banking and Negotiable Instruments",
      "Alternative Dispute Resolution",
      "Professional Ethics and Professional Accounting",
    ],
    6: [
      "Law of Taxation",
      "Information Technology Law",
      "Optional- Law Relating to Women",
      "Optional- Human Rights Law",
      "Drafting Pleadings and Conveyancing",
    ],
  },
};

function PYQs() {
  const { currentUser, loading } = useContext(AuthContext);
  const location = useLocation();
  const isLoggedIn = !!currentUser;

  const [guestNoteOpened, setGuestNoteOpened] = useState(
    localStorage.getItem("guestNoteOpened") === "true",
  );
  const [isBlurred, setIsBlurred] = useState(false);

  const { degree, course, semester, subject } = useParams();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null); // null | "EMPTY" | "NOT_FOUND" | array

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSubject, setPreviewSubject] = useState(null);
  const [previewSemester, setPreviewSemester] = useState(null);
  const [previewCourse, setPreviewCourse] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const [noteText, setNoteText] = useState(""); // NEW: For SEO indexing
  const [showPYQNotice, setShowPYQNotice] = useState(true);

  useEffect(() => {
    if (previewFile) {
      fetch(previewFile)
        .then((res) => res.text())
        .then((html) => {
          // Strip HTML tags to get clean text for Google
          const doc = new DOMParser().parseFromString(html, "text/html");
          setNoteText(doc.body.innerText || "");
        })
        .catch(() => setNoteText(""));
    } else {
      setNoteText("");
    }
  }, [previewFile]);

  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  const [isSwiping, setIsSwiping] = useState(false);

  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();

    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ["s", "c", "u", "p"].includes(e.key.toLowerCase())
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (loading) return; // Wait for auth to initialize

    if (subject && semester) {
      if (!isLoggedIn) {
        if (guestNoteOpened) {
          navigate("/auth", { state: { from: location } });
          return;
        }
        setGuestNoteOpened(true);
        localStorage.setItem("guestNoteOpened", "true");
      }

      const findSubjectFromSlug = (slug, courseName, sem) => {
        const list = subjects[courseName]?.[sem] || [];
        return list.find(
          (sub) => sub.toLowerCase().replace(/[^a-z0-9]+/g, "-") === slug,
        );
      };

      const decodedSubject =
        degree === "3YDC"
          ? findSubjectFromSlug(subject, "3YDC", semester)
          : findSubjectFromSlug(subject, course, semester);

      if (!decodedSubject) {
        navigate(-1);
        return;
      }
      setPreviewOpen(true);
      setPreviewSubject(decodedSubject);
      setPreviewSemester(Number(semester));

      if (degree === "3YDC") {
        setPreviewCourse("3YDC");

        const encodedFile = encodeURIComponent(decodedSubject);

        setPreviewFile(
          `/PYQs/3YDC/Semester - ${semester}/${encodedFile}.html`,
        );
      } else if (course) {
        setPreviewCourse(course);
        setPreviewFile(
          `/PYQs/${course}/Semester - ${semester}/${encodeURIComponent(decodedSubject)}.html`,
        );
      }
    } else {
      setPreviewOpen(false);
    }
  }, [
    degree,
    course,
    semester,
    subject,
    navigate,
    loading,
    isLoggedIn,
    guestNoteOpened,
    location,
  ]);

  useEffect(() => {
    if (previewOpen) {
      // Disable scroll
      document.body.style.overflow = "hidden";
    } else {
      // Enable scroll
      document.body.style.overflow = "";
    }

    // Cleanup on unmount to reset for safety
    return () => {
      document.body.style.overflow = "";
    };
  }, [previewOpen]);

  useEffect(() => {
    if (previewOpen && !isLoggedIn) {
      setIsBlurred(false);

      const timer = setTimeout(() => {
        setIsBlurred(true);
      }, 25000);

      return () => clearTimeout(timer);
    }
  }, [previewOpen, isLoggedIn]);

  // Per-course active indices for gallery
  const [activeIndexes, setActiveIndexes] = useState({
    BALLB: 0,
    BBALLB: 0,
    BCOMLLB: 0,
    "3YDC": 0,
  });

  const galleryRef = useRef(null);
  const containerRef = useRef(null);

  // Handle search on Enter
  const handleSearch = (e) => {
    if (e.key === "Enter") {
      if (!searchQuery.trim()) {
        setSearchResults("EMPTY");
        return;
      }
      const results = [];
      Object.keys(subjects).forEach((course) => {
        Object.keys(subjects[course]).forEach((sem) => {
          subjects[course][sem].forEach((sub, idx) => {
            if (sub.toLowerCase().includes(searchQuery.toLowerCase())) {
              results.push({
                course,
                semester: sem,
                subject: sub,
                noteIndex: idx + 1,
              });
            }
          });
        });
      });
      if (results.length > 0) {
        setSearchResults(results);
      } else {
        setSearchResults("NOT_FOUND");
      }
    }
  };

  // Search Results UI
  const renderSearchResults = () => {
    if (!searchResults) return null;

    if (searchResults === "EMPTY") {
      return <p className="Psearch-message">Please type the subject name...</p>;
    }
    if (searchResults === "NOT_FOUND") {
      return <p className="Psearch-message">No Subject Found...</p>;
    }
    return (
      <div className="Psearch-results">
        <h2>Search Results...</h2>
        <div className="PYQs-row">
          {searchResults.map((result, idx) => (
            <div
              key={idx}
              className="Psemester-container"
              onClick={() => {
                const { course, semester, subject } = result;

                const slug = subject.toLowerCase().replace(/[^a-z0-9]+/g, "-");

                if (course === "3YDC") {
                  navigate(`/pyqs/3YDC/OU/${semester}/${slug}`);
                } else {
                  navigate(`/pyqs/5YDC/${course}/${semester}/${slug}`);
                }
              }}
            >
              <div className="Psemester-spine"></div>
              <div className="Psemester-cover">
                <div className="Psemester-title-rect clickable">
                  <img src={Scale} alt="Note" className="Psemester-icon" />
                  <div className="Psemester-title">{result.subject}</div>
                  <div className="Psemester-comment">
                    {result.course} - Sem {result.semester}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  // Semester renderers
  const renderSemesters5YDC = (courseName) => {
    // If no semester is selected yet, show only semester blocks
    if (!semester) {
      const semesters = Array.from({ length: 10 }, (_, i) => i + 1);
      return (
        <div className="Psemesters">
          {semesters.map((sem) => (
            <div key={sem} className="Psemester-block1">
              <div
                className="Psemester-title-rect1 clickable"
                onClick={() => navigate(`/pyqs/5YDC/${courseName}/${sem}`)}
              >
                <div className="Psemester-title1">Semester {sem}</div>
                <div className="Psemester-comment1">{courseName}</div>
              </div>
            </div>
          ))}
        </div>
      );
    }

    // If a semester is selected, show only that semester's subjects
    const sem = semester;
    const semesterSubjects = subjects[courseName]?.[sem] || [];
    const toSlug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
    return (
      <div className="Psemesters">
        <div className="Psemester-block" id={`semester-${sem}`}>
          <h3>Semester {sem}</h3>
          <div className="PYQs-row">
            {semesterSubjects.map((subject, idx) => (
              <div key={idx} className="Psemester-container">
                <div className="Psemester-spine"></div>
                <div className="Psemester-cover">
                  <div
                    className="Psemester-title-rect clickable"
                    onClick={() =>
                      navigate(
                        `/pyqs/5YDC/${courseName}/${sem}/${toSlug(subject)}`,
                      )
                    }
                  >
                    <img src={Scale} alt="Note" className="Psemester-icon" />
                    <div className="Psemester-title">{subject}</div>
                    <div className="Psemester-comment">
                      {courseName} - Sem {sem}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Optional: back to all semesters button */}
          <button
            className="Pback-button"
            onClick={() => {
              navigate(`/pyqs/5YDC/${courseName}`);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Back to Semesters
          </button>
        </div>
      </div>
    );
  };
  // Semester renderers for 3YDC
  const renderSemesters3YDC = (courseName) => {
    // 1) If no semester is selected yet, show only 6 semester blocks
    if (!semester) {
      const semesters = Array.from({ length: 6 }, (_, i) => i + 1);
      return (
        <div className="Psemesters">
          {semesters.map((sem) => (
            <div key={sem} className="Psemester-block1">
              <div
                className="Psemester-title-rect1 clickable"
                onClick={() => navigate(`/pyqs/3YDC/OU/${sem}`)}
              >
                <div className="Psemester-title1">Semester {sem}</div>
                <div className="Psemester-comment1">{courseName}</div>
              </div>
            </div>
          ))}
        </div>
      );
    }

    // 2) If a semester is selected, show only that semester's subjects
    const sem = semester;
    const semesterSubjects = subjects[courseName]?.[sem] || [];
    const toSlug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
    return (
      <div className="Psemesters">
        <div className="Psemester-block" id={`semester-${sem}`}>
          <h3>Semester {sem}</h3>
          <div className="PYQs-row">
            {semesterSubjects.map((subject, idx) => (
              <div key={idx} className="Psemester-container">
                <div className="Psemester-spine"></div>
                <div className="Psemester-cover">
                  <div
                    className="Psemester-title-rect clickable"
                    onClick={() =>
                      navigate(`/pyqs/3YDC/OU/${sem}/${toSlug(subject)}`)
                    }
                  >
                    <img src={Scale} alt="Note" className="Psemester-icon" />
                    <div className="Psemester-title">{subject}</div>
                    <div className="Psemester-comment">
                      {courseName} - Sem {sem}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Back to all semesters for 3YDC */}
          <button
            className="Pback-button"
            onClick={() => {
              navigate("/pyqs/3YDC");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Back to Semesters
          </button>
        </div>
      </div>
    );
  };

  // Main content rendering
  const renderContent = () => {
    if (!degree) {
      return (
        <div className="Pdefault-content">
          {renderSearchResults()}
          <h2>Select your Course</h2>
          <div className="Pcourse-row">
            <div
              className="Pcourse-container"
              onClick={() => navigate("/pyqs/5YDC")}
            >
              <div className="Pcourse-cover">
                <div className="Pcourse-title-rect">
                  <img src={Scale} alt="Scale" className="Pcourse-icon" />
                  <div className="Pcourse-title">5YDC</div>
                  <div className="Pcourse-comment">
                    Five Years Degree Course
                  </div>
                </div>
              </div>
            </div>

            <div
              className="Pcourse-container"
              onClick={() => navigate("/pyqs/3YDC")}
            >
              <div className="Pcourse-cover">
                <div className="Pcourse-title-rect">
                  <img src={Scale} alt="Scale" className="Pcourse-icon" />
                  <div className="Pcourse-title">3YDC</div>
                  <div className="Pcourse-comment">
                    Three Years Degree Course
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (degree === "5YDC" && !course) {
      return (
        <div className="Ptab-content">
          {renderSearchResults()}
          <button
            className="Pback-button"
            onClick={() => {
              navigate(-1);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Back
          </button>
          <h2 className="Ptab-heading">5 Years Degree Courses</h2>
          <h3 className="Ptab-subheading">Select your Course...</h3>
          <div className="Psubcourse-row">
            <div
              className="Psubcourse-block"
              onClick={() => navigate("/pyqs/5YDC/BALLB")}
            >
              BA.LLB
            </div>
            <div
              className="Psubcourse-block"
              onClick={() => navigate("/pyqs/5YDC/BBALLB")}
            >
              BBA.LLB
            </div>
            <div
              className="Psubcourse-block"
              onClick={() => navigate("/pyqs/5YDC/BCOMLLB")}
            >
              BCOM.LLB
            </div>
          </div>
        </div>
      );
    }

    if (degree === "5YDC" && course) {
      return (
        <div className="Ptab-content">
          {renderSearchResults()}
          <button
            className="Pback-button"
            onClick={() => {
              navigate(-1);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Back
          </button>
          <h2 className="Ptab-heading">{course}</h2>
          <h3 className="Ptab-subheading">Open your PYQs...</h3>
          {renderSemesters5YDC(course)}
        </div>
      );
    }

    if (degree === "3YDC") {
      return (
        <div className="Ptab-content">
          {renderSearchResults()}
          <button
            className="Pback-button"
            onClick={() => {
              navigate(-1);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Back
          </button>
          <h2 className="Ptab-heading">3YDC</h2>
          <h3 className="Ptab-subheading">Open your PYQs...</h3>
          {renderSemesters3YDC("3YDC")}
        </div>
      );
    }

    return null;
  };

  // Gallery helpers
  const generateSemesterBlocks = (courseName) => {
    if (!subjects[courseName]) return [];
    return Object.keys(subjects[courseName]).map((sem) => ({
      heading: `Semester ${sem}`,
      statement: `${courseName}`,
    }));
  };

  // Gallery UI for a given course
  const renderGallery = (courseName, degreeType = "5YDC") => {
    const blocks = generateSemesterBlocks(courseName);
    if (!blocks.length) return null;
    const activeIndex = activeIndexes[courseName] ?? 0;

    // Moves gallery index safely
    const prev = () =>
      updateActiveIndex(courseName, activeIndex - 1, blocks.length);
    const next = () =>
      updateActiveIndex(courseName, activeIndex + 1, blocks.length);

    // for visible items: previous, current, next (always 3)
    const getVisibleItems = () => {
      const prevI = (activeIndex - 1 + blocks.length) % blocks.length;
      const nextI = (activeIndex + 1) % blocks.length;
      return [prevI, activeIndex, nextI];
    };

    function updateActiveIndex(course, newIndex, total) {
      setActiveIndexes((prev) => ({
        ...prev,
        [course]: ((newIndex % total) + total) % total, // wrap around safely
      }));
    }

    return (
      <section className="Pcourse-section" key={courseName}>
        <h2 className="Pfeatures-heading">{courseName} PYQs</h2>
        <div className="Pgallery-wrapper" ref={galleryRef}>
          <div className="Parrow Parrow-left" onClick={prev}></div>
          <div
            className="Pgallery-container"
            ref={containerRef}
            onTouchStart={(e) => {
              setTouchStartX(e.touches[0].clientX);
              setTouchEndX(e.touches[0].clientX);
              setIsSwiping(false);
            }}
            onTouchMove={(e) => {
              const deltaX = e.touches[0].clientX - touchStartX;
              setTouchEndX(e.touches[0].clientX);
              if (Math.abs(deltaX) > 20) {
                // threshold for swipe
                setIsSwiping(true);
              }
            }}
            onTouchEnd={() => {
              if (touchStartX - touchEndX > 50) {
                next();
              } else if (touchEndX - touchStartX > 50) {
                prev();
              }
              setTouchStartX(0);
              setTouchEndX(0);
              // Don't reset isSwiping here!
            }}
          >
            {getVisibleItems().map((index) => (
              <div
                key={index}
                className={`Pgallery-item ${index === activeIndex ? "active" : ""
                  }`}
                onClick={() => {
                  if (isSwiping) return;

                  if (degreeType === "3YDC") {
                    navigate(`/pyqs/3YDC/OU/${index + 1}`);
                  } else {
                    navigate(`/pyqs/5YDC/${courseName}/${index + 1}`);
                  }
                }}
              >
                <div className="Pblock-content">
                  <img src={Scale} alt="Scale" className="Pblock-icon" />

                  <h3 className="Pblock-heading">{blocks[index].heading}</h3>
                  <p className="Pblock-text">{blocks[index].statement}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="Parrow Parrow-right" onClick={next}></div>
        </div>
        <div className="Pdots">
          {blocks.map((_, idx) => (
            <span
              key={idx}
              className={`Pdot ${idx === activeIndex ? "active" : ""}`}
              onClick={() => updateActiveIndex(courseName, idx, blocks.length)}
            ></span>
          ))}
        </div>
      </section>
    );
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    time: new Date().toLocaleString(),
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccess(false);
    setError(false);

    const templateParams = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      time: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "service_TejCodex",
        "template_9w26kov",
        templateParams,
        "-1wDk-Z48uDBTDyvr",
      )
      .then(
        () => {
          setIsSubmitting(false);
          setSuccess(true);
          setFormData({ name: "", email: "", message: "" });
        },
        () => {
          setIsSubmitting(false);
          setError(true);
        },
      );
  };

  useEffect(() => {
    let timer;
    if (success || error) {
      timer = setTimeout(() => {
        setSuccess(false);
        setError(false);
      }, 10000); // 10 seconds = 10000 ms
    }
    return () => clearTimeout(timer);
  }, [success, error]);

  // Return main page layout
  return (
    <div className="PYQs">
      {!previewOpen && <Navbar />}
      <div className="Pmsg-trapezium">
        <div className="Pmsg-trapezium-black1"></div>
        <div className="Pmsg-trapezium-white1"></div>
      </div>
      <div className="Pmsg-trapezium-black2"></div>
      <div className="Pmsg-trapezium-white2"></div>
      <h1 className="PYQs-heading">PYQs</h1>
      <p className="PYQs-subheading">
        Access your study material by selecting a course or searching
        directly...
      </p>
      <div className="Pcontent-box">
        <div className="Pcontent-header">
          <div className="Ptabs">
            <button
              className={`Ptab ${degree === "5YDC" ? "active" : ""}`}
              onClick={() => {
                navigate("/pyqs/5YDC");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              5YDC
            </button>
            <button
              className={`Ptab ${degree === "3YDC" ? "active" : ""}`}
              onClick={() => {
                navigate("/pyqs/3YDC");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              3YDC
            </button>
          </div>
          <div className="Psearch-bar">
            <input
              type="text"
              placeholder="Search Subjects..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() === "") {
                  setSearchResults(null);
                }
              }}
              onKeyDown={handleSearch}
            />
          </div>
        </div>
        <div className="Pcontent-body">{renderContent()}</div>
      </div>
      {/* PYQ Notice Popup */}
      {previewOpen && showPYQNotice && (
        <div className="pyq-notice-popup">
          <div className="pyq-notice-content">
            <p>
              <strong>Notice:</strong> Previous Year Question Papers for this
              subject are currently being compiled and updated.
              <br />
              <br /> 
              Meanwhile, please refer to the provided Notes content for preparation,
              as most examination questions are directly based on the syllabus topics.
              <br />
              <br />
              To effectively cover the semester examination, it is strongly
              recommended to study at least <strong>3 units</strong> from the
              complete syllabus thoroughly.
            </p>

            <button
              className="pyq-notice-close"
              onClick={() => setShowPYQNotice(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
      {previewOpen && (
        <NotePreview
          course={previewCourse}
          semester={previewSemester}
          subject={previewSubject}
          fileName={previewFile}
          onClose={() => {
            if (degree === "3YDC") {
              navigate(`/pyqs/3YDC/OU/${semester}`);
            } else if (degree && course && semester) {
              navigate(`/pyqs/5YDC/${course}/${semester}`);
            } else {
              navigate(-1);
            }
          }}
          isBlurred={isBlurred}
          isLoggedIn={isLoggedIn}
        />
      )}

      {/* SEO: Visually hidden but indexable note content */}
      <div className="seo-hidden-content" aria-label="Note content preview">
        {noteText}
      </div>

      {!degree && (
        <>
          {renderGallery("BALLB", "5YDC")}
          {renderGallery("3YDC", "3YDC")}
          {renderGallery("BBALLB", "5YDC")}
          {renderGallery("BCOMLLB", "5YDC")}
        </>
      )}

      <section className="Pstudy-tips-section">
        <h2 className="Pstudy-tips-heading">📚 TejCodex Study Tips...</h2>
        <p className="Pstudy-tips-subheading">
          Make the most out of your Notes with these effective habits!
        </p>

        <div className="Ptips-container">
          <div className="Ptip-card">
            <span className="Ptip-emoji">⏰</span>
            <div className="Ptip-content">
              <h3>Study in Intervals</h3>
              <p>
                Use the Pomodoro technique: 25 mins study, 5 mins break. Helps
                retain info better!
              </p>
            </div>
          </div>

          <div className="Ptip-card">
            <span className="Ptip-emoji">📝</span>
            <div className="Ptip-content">
              <h3>Take Notes Actively</h3>
              <p>
                Rewrite key points in your own words while reading the Notes. It
                enhances memory.
              </p>
            </div>
          </div>

          <div className="Ptip-card">
            <span className="Ptip-emoji">🌞</span>
            <div className="Ptip-content">
              <h3>Study in Morning Hours</h3>
              <p>
                Your mind is fresh in the morning, making it ideal for tough
                subjects.
              </p>
            </div>
          </div>

          <div className="Ptip-card">
            <span className="Ptip-emoji">🎧</span>
            <div className="Ptip-content">
              <h3>Use Background Music</h3>
              <p>
                Soft instrumental music can boost focus and reduce stress while
                studying.
              </p>
            </div>
          </div>

          <div className="Ptip-card">
            <span className="Ptip-emoji">🛏️</span>
            <div className="Ptip-content">
              <h3>Take Proper Breaks</h3>
              <p>
                Don’t overwork. Short naps or walks help your brain absorb more
                efficiently.
              </p>
            </div>
          </div>

          <div className="Ptip-card">
            <span className="Ptip-emoji">📖</span>
            <div className="Ptip-content">
              <h3>Revise Regularly</h3>
              <p>
                Go through previous semester Notes weekly to reinforce learning.
              </p>
            </div>
          </div>
        </div>
      </section>

      <HomeContactSection
        scale={Scale}
        formData={formData}
        loading={isSubmitting}
        success={success}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />

      {/* Hidden links for Google crawling */}
      {!degree && (
        <div style={{ display: "none" }}>
          {Object.keys(subjects).map((course) =>
            Object.keys(subjects[course]).map((sem) =>
              subjects[course][sem].map((sub) => {
                const slug = sub.toLowerCase().replace(/[^a-z0-9]+/g, "-");
                const url =
                  course === "3YDC"
                    ? `/pyqs/3YDC/OU/${sem}/${slug}`
                    : `/pyqs/5YDC/${course}/${sem}/${slug}`;
                return (
                  <a key={`${course}-${sem}-${slug}`} href={url}>
                    {sub}
                  </a>
                );
              }),
            ),
          )}
        </div>
      )}

      <footer className="footer-section">
        <div className="footer-top">
          <img src={Scale} alt="Scale" className="footer-logo" />
          <span className="footer-title">TejCodex</span>
          <span className="footer-rights">© 2025 All rights reserved.</span>
        </div>

        <div className="footer-links">
          <a href="/">Home</a> |<a href="/notes"> Notes</a> |
          <a href="/pyqs"> PYQs</a> | <a href="/aibe-preparation"> AIBE</a> | <a href="/about"> About Us</a> |
          <a href="/contact"> Contact Us</a>
        </div>
      </footer>
    </div>
  );
}

export default PYQs;
